import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class ManageBookingFilterButton extends Component {
  static propTypes = {
    showAllFilters: PropTypes.func.isRequired,
    downloadAllKeyinstructionsLink: PropTypes.bool.optional,
    manageGuestDetailsLink: PropTypes.bool.optional,
  }

  showAllFilters = () => this.props.showAllFilters()

  render () {
    const addMarginsToButton = {
          margin: '2px',
    };

    return (

        <div className="stage-actions">
            <div className="stage-actions__buttons">
                <button className='btn btn--primary' style={addMarginsToButton} onClick={this.showAllFilters}>
                    All filters
                </button>
                <div className="divider"/>
                <button className='btn btn--primary' style={addMarginsToButton} onClick={()=> window.open(this.props.downloadAllKeyinstructionsLink)}>
                    Download All Key Instructions
                </button>
                <div className="divider"/>
                <button className='btn btn--primary' style={addMarginsToButton} id="extra-services-request-btn">
                    Akommo Extra Services
                </button>

                <button className='btn btn--primary' style={addMarginsToButton} onClick={()=> window.open(this.props.manageGuestDetailsLink)}>
                    Manage Guest Details
                </button>
                {/*  <input type="submit" name="action" value="Request Extras" class="btn btn--primary"></input> todo to be implemented in the next update */}
            </div>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ManageBookingFilterButton.js